// @flow

import { beginRequest, completeRequest } from "@store/utils";

import type { ManagerSmsNotificationsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

// Get Manager Sms Settings

export const onGetManagerSmsSettings = (state: ManagerSmsNotificationsState) => () =>
  startRequest(state);

export const onGetManagerSmsSettingsSuccess = (state: ManagerSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  settings: payload,
});

export const onGetManagerSmsSettingsError = (state: ManagerSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Manager Sms Notifications

export const onGetManagerSmsNotificationsSmsRules = (state: ManagerSmsNotificationsState) => () =>
  startRequest(state);

export const onGetManagerSmsNotificationsSmsRulesSuccess = (
  state: ManagerSmsNotificationsState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  smsRules: payload,
});

export const onGetManagerSmsNotificationsSmsRulesError = (state: ManagerSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Manager Pager Rules

export const onGetManagerSmsNotificationsPagerRules = (state: ManagerSmsNotificationsState) => () =>
  startRequest(state);

export const onGetManagerSmsNotificationsPagerRulesSuccess = (
  state: ManagerSmsNotificationsState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  pagerRules: payload,
});

export const onGetManagerSmsNotificationsPagerRulesError = (
  state: ManagerSmsNotificationsState,
) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create Manager Sms Notifications

export const onSetManagerSmsNotificationCurrent = (state: ManagerSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  current: payload,
});

export const onSetManagerSmsNotificationAssignments = (state: ManagerSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  assignments: payload,
});

// Modals

export const onSetShowAddModal = (state: ManagerSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddModal: payload,
  },
});

export const onSetShowEditModal = (state: ManagerSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onSetShowDeleteModal = (state: ManagerSmsNotificationsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeleteModal: payload,
  },
});
